import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";

import { store } from "./app/store";
import AppRouter from "./routes/AppRouter";
import { setBranding } from "./features/branding/brandingSlice";
import { API } from "./constant/apiConstant";
import AdminSessionTimeoutManager from "./components/AdminSessionTimeoutManager";

function AdminAppShell() {
const dispatch = useDispatch();

useEffect(() => {
  const loadBranding = async () => {
    try {
      const response = await fetch(`${API.BASE_URL}/api/settings`);
      const data = await response.json();

      if (data?.status) {
        dispatch(
          setBranding({
            logoUrl: data.settings?.logo_url || "",
            logoWidth: data.settings?.logo_width || 96,
            logoHeight: data.settings?.logo_height || 96
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  loadBranding();
}, [dispatch]);

return (
  <BrowserRouter>
    <AdminSessionTimeoutManager />
    <AppRouter />
  </BrowserRouter>
);
}

function App() {

return (

<Provider store={store}>
<AdminAppShell />

</Provider>

);

}

export default App;
